var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlingshotLogo2020RevHoriz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 306 306",
    style: {
      enableBackground: "new 0 0 306 306"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.6;fill:#FFFFFF;}\n\t.st2{fill:#F1592B;}\n\t.st3{opacity:0.2;fill:#6D6E71;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.1,144.4c-2.5,1.9-5,3.7-7.6,5.5c-2.5,1.8-5.2,3.4-7.8,5.2c-2.6,1.7-5.3,3.3-8,4.9 c-2.7,1.6-5.4,3-8.1,4.6c-5.5,3-11.1,5.7-16.7,8.3c-0.4,0.2-0.8,0.3-1.2,0.5c33.8,2.3,36.1,27.8,18,45.9 c-18.9,18.9-78.4,27.3-119.2-6.1l-3.7-2.5l1.5,2.7c2.8,4,5.9,7.8,9.2,11.5c41.6,45.7,110.1,49.2,153,7.8 c28.4-27.4,38.1-65.3,29.6-103.6c-0.1-0.4-4.5-13.2-6.1-16.9c-1.8,2.3-3.6,4.6-5.5,6.8C250.4,128.5,241,136.9,231.1,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.7,170.4c35.6,0.1,70.5-10.2,103.1-24.2c19.7-8.5,38.8-18.3,57.8-28.3c-17.9,5.8-46.7,12.6-81.8,14.9 c-35.9,2.3-39.8-27.4-21.1-46.1c18.9-18.9,78.4-27.3,119.2,6.1l3.7,2.5l-1.5-2.7c-2.8-4-5.9-7.8-9.2-11.5 c-41.6-45.7-110.1-49.2-153-7.8C71.7,98.5,61.4,132.8,66.6,168c0.2,0.1,0.4,0.2,0.7,0.3C71.3,170,76.2,170.4,80.7,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M258,119.9c-8.1,9.1-17.2,17.2-26.9,24.6c-2.5,1.9-5,3.7-7.6,5.5c-2.5,1.8-5.2,3.4-7.8,5.2 c-2.6,1.7-5.3,3.3-8,4.9c-2.7,1.6-5.4,3-8.1,4.6c-5.5,3-11.1,5.7-16.7,8.3c-0.4,0.2-0.8,0.3-1.2,0.5c7.4,0.5,13.3,2.1,17.8,4.6 c4.3-2.4,8.6-4.9,12.8-7.5c20.5-12.4,40.5-26.3,57.2-43.5c-1-2.9-2.9-8.3-4.2-11.9C262.6,116.9,260,118.5,258,119.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.8,110.6c-2.9,0.4-14,3.6-19.7,5.3c-1.4,1-2.7,1.9-3.9,2.7c-19.3,12.5-39.4,23.7-60.2,33.4 c-32.8,15.3-68.3,25.9-104.5,26.2c-9.2,0.1-20.2-1.7-23.9-10.1c-2.7-6.3,0-13.5,2.7-19.8c-5.5,2-9.1,7.3-10.8,12.9 c-4.6,14.4,1.9,31.5,14.9,39.2c9.1,5.4,20.3,6.3,30.9,5.7c38.9-2,75.4-19.5,108.8-39.4c22.5-13.4,44.4-28.7,61.9-48.2 c0.6-0.7,3.7-4.1,7.1-8c-0.4,0-0.7-0.1-1.1-0.1C273.4,110.4,272.6,110.4,271.8,110.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.1,67.7C307,67.7,307,67.7,307.1,67.7c-0.4,0.3-57.7,44.5-57.7,44.5c0,0-0.1,0.1,0,0.1 c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,17.8-5.3,21.9-5.9c1-0.2,1.9-0.2,2.8-0.2c8.4,0,11.8,6.8,13.5,12.7c0,0,0,0.1,0.1,0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0-0.1,1.6-13.9,8.3-28c7.5-16,11-22.9,11.1-23C307.2,67.8,307.2,67.8,307.1,67.7 C307.1,67.7,307.1,67.7,307.1,67.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlingshotLogo2020RevHoriz);
export default __webpack_public_path__ + "static/media/Slingshot_Logo_2020_rev_horiz.0ef14de8c4c79d365cca418549478169.svg";
export { ForwardRef as ReactComponent };